import { Layout, UserLogSystem } from "components"
export const UserLog = () => {
 return (
  <Layout>
   <UserLogSystem />
  </Layout>
 )
}
